import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/tailwind.css'
import analyticsService from './services/analyticsService'

// Router-Events für Analytics nur wenn Consent vorliegt
if (process.env.NODE_ENV === 'production') {
  router.afterEach((to) => {
    analyticsService.trackPageView(to.path, to.meta.title || 'IT-Meeder');
  });
}

// Vue Devtools in Produktion deaktivieren für DSGVO-Konformität
if (process.env.NODE_ENV === 'production') {
  const app = createApp(App)
  app.config.devtools = false
  app.config.debug = false
  app.config.silent = true
  app.use(store)
  app.use(router)
  app.mount('#app')
} else {
  // Normale Initialisierung für Development
  const app = createApp(App)
  app.use(store)
  app.use(router)
  app.mount('#app')
}

// Debug-Modus im Entwicklung für bessere Fehlermeldungen
if (process.env.NODE_ENV === 'development') {
  // Running in development mode
  
  // Store-Daten verfügbar für Debug-Tools
} 